import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

const CAMPAIGN_PARAM = 'registration_code';

export function captureCampaignRegistrationCode(search: string): void {
  const code = new URLSearchParams(search).get(CAMPAIGN_PARAM)?.trim();
  if (code) {
    StorageHandler.save(storageKeys.campaignRegistrationCode, code);
  }
}

export function getCampaignRegistrationCode(): Promise<string | null> {
  return (StorageHandler.load(storageKeys.campaignRegistrationCode) as Promise<string | false>).then(
    (code) => code || null,
  );
}

export function clearCampaignRegistrationCode(): void {
  StorageHandler.remove(storageKeys.campaignRegistrationCode);
}
